import React from 'react';
import '../assets/styles/SearchCard.css';

const SearchCard = ({ data, color }) => {
  // Fonction qui rend le contenu spécifique en fonction du type
  const renderCardContent = () => {
    switch (data.type) {
      case 'publication':
        return (
          <>
            <h3>{data.title} ({data.type})</h3>
            <p>By: {data.user.first_name} {data.user.last_name}</p>
            <p>Email: {data.user.email}</p>
            <p>Type: {data.type}</p>
          </>
        );
      case 'project':
        return (
          <>
            <h3>{data.title} ({data.type})</h3>
            <p>Description: {data.description}</p>
            <p>Start Date: {data.start_date}</p>
            <p>End Date: {data.end_date}</p>
            
          </>
        );
      case 'request':
        return (
          <>
            <h3>{data.title} ({data.type})</h3>
            <p>Description: {data.request_description}</p>
            
            {data.exec_partner.first_name ? (
              <p>Exec Partner: {data.exec_partner.first_name} {data.exec_partner.last_name}</p>
            ) : (
              <p>Exec Partner: N/A</p>
            )}
          </>
        );
      case 'exec':
        return (
          <>
            <h3>{data.user.first_name} {data.user.last_name} ({data.type})</h3>
            <p>Email: {data.user.email}</p>
            <div>
              <h4>Sectors:</h4>
              <ul>
                {data.sectors.map(sector => (
                  <li key={sector.id}>{sector.name}</li>
                ))}
              </ul>
            </div>
            <div>
              <h4>Practices:</h4>
              <ul>
                {data.practices.map(practice => (
                  <li key={practice.id}>{practice.name}</li>
                ))}
              </ul>
            </div>
          </>
        );
      default:
        return <p>Unknown type</p>;
    }
  };

  return (
    <div className="card">
      {renderCardContent()}
    </div>
  );
};

export default SearchCard;